interface TabService {
  switchTo: (tabId: string) => void
}

export const tabService: TabService = {
  switchTo: (tabId: string) => {
    // Note: This only works if you have the pendant-tab-control chrome extension installed on your browser (https://github.com/VentionCo/pendant-tab-control)
    // The chrome extension binds an event listener to the :root element to inject functionality that interacts with the browser.
    const switchTabsEvent = new Event('switchTabs');
    const rootElement = document.querySelector(':root');
    rootElement?.dispatchEvent(switchTabsEvent);
  },
};
